/**
 * ResetPasswordForm — standalone page at /reset-password?token=...
 * Rendered while logged out (no Router context available at that point in
 * App.js), so this reads the token straight from window.location rather
 * than react-router hooks.
 */

import React, { useState } from 'react';
import axios from 'axios';

function ResetPasswordForm() {
  const token = new URLSearchParams(window.location.search).get('token') || '';

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!newPassword || !confirmPassword) {
      setError('Please fill in both password fields');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/reset-password`, {
        token,
        newPassword
      });
      setSuccess(true);
    } catch (err) {
      setError(
        err.response?.data?.message ||
        'Something went wrong. Please request a new reset link and try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-container">
        <div className="login-box">
          <h2>Reset Password</h2>
          <div className="alert alert-danger" role="alert" style={{ marginBottom: '15px', fontSize: '0.9rem' }}>
            This reset link is missing its token. Please use the link from your email, or request a new one from the login page.
          </div>
          <a href="/">Back to Login</a>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="login-container">
        <div className="login-box">
          <h2>Password Reset</h2>
          <p style={{ marginBottom: '20px' }}>
            Your password has been reset successfully. You can now log in with your new password.
          </p>
          <a href="/">Go to Login</a>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Reset Password</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>New Password:</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => { setNewPassword(e.target.value); if (error) setError(''); }}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Confirm New Password:</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => { setConfirmPassword(e.target.value); if (error) setError(''); }}
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" disabled={loading}>
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
        <div className="login-footer">
          <p><a href="/">Back to Login</a></p>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordForm;
